// extracted by mini-css-extract-plugin
module.exports = {"ratioText":"CompletedRatio_ratioText__UFTDY"};